import React, { useContext } from 'react';

export type CssVariable = { name: string; value: string };

interface LayoutContextProps {
    decorate: boolean;
    withoutSidebar: boolean;
    withoutHeader: boolean;
    fullScreen: boolean;
    centered: boolean;
    withBackground: boolean;
    menuOpen: boolean;
    menuPin: boolean;
    isMobile: boolean;
    tabOpen: boolean;
    setDecorate: (value: boolean) => void;
    setWithoutSidebar: (value: boolean) => void;
    setWithoutHeader: (value: boolean) => void;
    setFullScreen: (value: boolean) => void;
    setCentered: (value: boolean) => void;
    setWithBackground: (value: boolean) => void;
    setLayoutCssProperty: (vars: CssVariable | Array<CssVariable>) => void;
    setMenuOpen: (open: boolean) => void;
    toggleMenu: (open?: boolean) => void;
    setMenuPin: (pin: boolean) => void;
    setIsMobile: (mobile: boolean) => void;
    setTabOpen: (open: boolean) => void;
    toggleTab: (open?: boolean) => void;
}

const initialContext: LayoutContextProps = {
    decorate: false,
    withoutSidebar: false,
    withoutHeader: false,
    fullScreen: false,
    centered: false,
    withBackground: false,
    menuOpen: false,
    menuPin: false,
    isMobile: false,
    tabOpen: false,
    setDecorate: () => {},
    setWithoutSidebar: () => {},
    setWithoutHeader: () => {},
    setFullScreen: () => {},
    setCentered: () => {},
    setWithBackground: () => {},
    setLayoutCssProperty: () => {},
    setMenuOpen: () => {},
    toggleMenu: () => {},
    setMenuPin: () => {},
    setIsMobile: () => {},
    setTabOpen: () => {},
    toggleTab: () => {},
};
export const LayoutContext =
    React.createContext<LayoutContextProps>(initialContext);

export const useLayoutContext = (): LayoutContextProps => {
    return useContext(LayoutContext);
};
